var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaskAndTube(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.064 5.792c.736 0 1.312.576 1.312 1.312s-.544 1.312-1.248 1.344v5.792c0 1.152.416 2.816.96 3.904l3.232 5.664a559.164 559.164 0 002.656 4.64C24.288 30.72 22.944 32 21.568 32H2.944c-1.376 0-2.72-1.28-1.408-3.552L4.64 23.04c1.376-2.432 2.656-4.672 2.656-4.672.608-1.056 1.088-2.912 1.088-4.128V8.448c-.704-.032-1.248-.608-1.248-1.344s.576-1.312 1.312-1.312h7.616zm-.128 15.648h-7.36l-3.552 6.208c-.512.896-.096 1.696.928 1.76H18.56c1.024-.064 1.44-.864.928-1.76l-3.552-6.208zM30.048 0c.544 0 .96.384.96.864 0 .448-.352.8-.832.864h-.096v17.824c0 1.984-1.6 3.616-3.584 3.616h-.448a3.612 3.612 0 01-3.616-3.616V1.728c-.512 0-.928-.384-.928-.864 0-.448.384-.8.832-.864h7.712zm-4.096 6.112h-2.368v13.216c0 1.12.48 2.048 1.12 2.048h.128c.608 0 1.12-.928 1.12-2.048V6.112z"
  })));
}

export default SvgFlaskAndTube;